import { Link } from "react-router-dom";
import { useAuth } from "../Auth/AuthProvider";

import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    Box,
} from "@mui/material"

export default function DefaultLayout({ ubication }) {
    const auth = useAuth();
    var home = "";
    var ubicacion = "";
    if (ubication !== 0) {
        home = <Button color="inherit" onClick={() => (window.location.href = "/")} >Home</Button>;
    }
    if (ubication !== 1) {
        if (auth.isAuthenticated) {
            ubicacion = <Button onClick={() => (window.location.href = "/dashboard")} color="inherit">Dashboard</Button>;
        }
        else {
            ubicacion = <Button onClick={() => (window.location.href = "/login")} color="inherit">Login</Button>;
        }
    }
    const data = (
        <AppBar position="static" color="transparent" elevation={0}>
            <Toolbar>
                <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
                    <img src="/logo192.png" alt="CesarBonilla Logo" style={{ height: 50, marginRight: 10 }} />
                    <Typography variant="h6" component="div">
                        Cesar Bonilla
                    </Typography>
                </Box>
                <Box sx={{ flexGrow: 1 }} />
                {home}
                {ubicacion}
            </Toolbar>
        </AppBar>
    );

    return (data);
}